import { render, staticRenderFns } from "./index--echarts-update.vue?vue&type=template&id=067aa31a&scoped=true&"
import script from "./index--echarts-update.vue?vue&type=script&lang=js&"
export * from "./index--echarts-update.vue?vue&type=script&lang=js&"
import style0 from "./index--echarts-update.vue?vue&type=style&index=0&id=067aa31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067aa31a",
  null
  
)

export default component.exports